<template lang="pug">
    .border.rounded.rounded-sm.p-3.flex.align-center.bg-white.shadow-sm
        slot
</template>

<script>
export default {
    name: "Block",
}
</script>